module.exports = __webpack_public_path__ + "static/media/darkmode-illustration.0c323a56.jpg";